import { render } from "./CreateNFT.vue?vue&type=template&id=1179e9ac&ts=true"
import script from "./CreateNFT.vue?vue&type=script&lang=ts"
export * from "./CreateNFT.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__